import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { getAllPackage } from "../Common/apis.js";
import img1 from "../Assets/Pilates.jpg";
import img2 from "../Assets/yoga.jpg";
import img3 from "../Assets/Reformer Bed.jpg";
import img4 from "../Assets/The Restore Suite.jpg";
import img5 from "../Assets/Pilates.jpg";
import img6 from "../Assets/Pilates.jpg";
import img7 from "../Assets/Pilates.jpg";
import img8 from "../Assets/Pilates.jpg";
import img9 from "../Assets/Pilates.jpg";
import img10 from "../Assets/Pilates.jpg";
import img11 from "../Assets/Pilates.jpg";

const packageImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img10,
  img11
];

function Package() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await getAllPackage();
      setPackages(result?.data);
    } catch (error) {
      console.error("Error fetching packages", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="aboutbanner aboutbanner2">
        <h3>Packages</h3>
        <p>Monthly, Weekly, Yearly</p>
      </div>

      <div className="updated-packages-cards">
        {loading ? (
          <div className="loader"></div>
        ) : packages.length > 0 ? (
          packages.map((pkg, index) => (
            <div className="alura-pack-card" key={index}>
              <div className="alura-pack-card-heading">
                <h3>{pkg.name}</h3>
              </div>
              <div className="alura-pack-card-text-box">
                <div className="alura-pack-card-text">
                  <h4>{pkg.description}</h4>
                  <h5>
                    {" "}
                    Classes:{" "}
                    {pkg.packageType === "Counted"
                      ? pkg.noOfDays
                      : "Unlimited"}{" "}
                    
                  </h5>
                  {/* <p>Duration: 30 classes</p> */}
                  <br />
                  <br />
                </div>
                <div className="alura-pack-card-button">
                  <Link className="w-100" to={`/package-checkout/${pkg?._id}`}>
                    <button>Book Now</button>
                  </Link>
                  
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No packages available</p>
        )}
      </div>

      {/* <div className="updated-packages-cards">
      {loading ? (
    <div className="loader"></div>
  ) : packages.length > 0 ? (
    packages.map((pkg, index) => (

      
      <div
        className="new-cards-pack"
        key={index}
        style={{
          backgroundImage: `url(${packageImages[index % packageImages.length]})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          color: '#fff', 
        }}
      >
      <div className="over-new">
      <div className="new-cards-pack-text">
          <h4>{pkg.name}</h4>
          <br />
          <h5>{pkg.description}</h5>
          <p>
            Duration:{' '}
            {pkg.packageType === 'Counted' ? pkg.noOfDays : 'Unlimited'} Classes
          </p>
          <br />
        </div>

        <Link className="w-100" to={`/package-checkout/${pkg?._id}`}>
          <button>Book Now</button>
        </Link>
      
      </div>
      <div className="updated-packages-card" key={index}>
      <div className="updated-packages-card-heading">
        <h4>
        {pkg.name}
        </h4>
        <div className="updated-rates">
<p>AED {pkg.amount}</p>
        </div>
      </div>
      <br/>
   
      <ul>
        <li>{pkg.description}</li>
        
      </ul>
      <p>Duration: {pkg.packageType === "Counted" ? pkg.noOfDays : "Unlimited"} Classes</p>

      <br/>
      <Link to={`/package-checkout/${pkg?._id}`}>
                <button>Book Now</button>
              </Link>

</div>
</div>

      ))
        ) : (
          <p>No packages available</p>
        )}
      </div>


      <div className="package-div">
        {loading ? (
          <div className="loader"></div>
        ) : packages.length > 0 ? (
          packages.map((pkg, index) => (
            <div key={index} className="package-div-section">
              <h2>{pkg.name}</h2>
              <h3>AED {pkg.amount}</h3>
              <p>{pkg.description}</p>
              <p>Duration: {pkg.packageType === "Counted" ? pkg.noOfDays : "Unlimited"} Classes</p>
              <br />
              <Link to={`/package-checkout/${pkg?._id}`}>
                <button>Book Now</button>
              </Link>
            </div>
          ))
        ) : (
          <p>No packages available</p>
        )}
      </div> */}
      <Footer />
    </>
  );
}

export default Package;
